export function moveItem<T>(items: T[], fromIndex: number, toIndex: number): T[] {
    const next = [...items];
    const [moved] = next.splice(fromIndex, 1);
    next.splice(toIndex, 0, moved);
    return next;
}

/**
 * Aplica a nova ordem imediatamente e persiste na API; em caso de falha
 * restaura a ordem anterior e propaga o erro para o chamador exibir a mensagem.
 */
export async function reorderOptimistic<T>(
    previous: T[],
    next: T[],
    getId: (item: T) => number,
    apply: (items: T[]) => void,
    persist: (ids: number[]) => Promise<void>,
): Promise<void> {
    apply(next);
    try {
        await persist(next.map(getId));
    } catch (error) {
        apply(previous);
        throw error;
    }
}
